import React from "react";
import BootstrapNavbar from "react-bootstrap/Navbar";
import { Button, Container, Nav } from "react-bootstrap";
import logo from "../assets/logo.png";
import WelshpoolLogo from "../assets/welshpool-logo.png";
import JourneyProgress from "./JourneyProgress";
import BackLink from "./BackLink";
import { ReactComponent as IconPhone } from "../assets/icon-phone.svg";
import { Link } from "react-router-dom";
import classes from "./Navbar.module.scss";
import { options } from "../services/rapidstor";

function Navbar() {
  const logoToUse = options.enabledLocations.includes("L005") ? WelshpoolLogo : logo;

  return (
    <BootstrapNavbar className={"border-bottom"}>
      <Container fluid className={classes.navbarContainer}>
        <Nav
          className={
            "justify-content-between align-items-end align-items-lg-center w-100"
          }
        >
          <BackLink className={"d-lg-none d-flex align-items-center nav-link"} />
          <BootstrapNavbar.Brand
            href={
              options.enabledLocations.includes("L005")
                ? "https://welshpoolselfstorage.com.au/"
                : "https://keepsafestorage.com.au/"
            }
          >
            <img
              src={logoToUse}
              style={{ maxWidth: 150 }}
              alt={"Logo of KeepSafe Storage"}
            />
          </BootstrapNavbar.Brand>
          <JourneyProgress className={"mx-4"} />

          {/* Desktop-only contact button */}
          <Link to={"/contact"} className={`d-none d-lg-inline hidden-link`}>
            <Button
              variant={"outline-primary"}
              className={`text-nowrap ${classes.contactUsButton}`}
            >
              Contact us <IconPhone className={"ms-2"} />
            </Button>
          </Link>

          {/* Mobile-only contact link */}
          <Link
            to={"/contact"}
            className={
              "d-lg-none hidden-link d-flex flex-column align-items-center opacity-50 text-dark p-2"
            }
          >
            <IconPhone className={"phone mb-1"} /> Contact
          </Link>
        </Nav>
      </Container>
    </BootstrapNavbar>
  );
}

export default Navbar;
